import script from "./Input.vue?vue&type=script&setup=true&lang=js"
export * from "./Input.vue?vue&type=script&setup=true&lang=js"

import "./Input.vue?vue&type=style&index=0&id=b2958e92&lang=postcss&scoped=true"
script.__scopeId = "data-v-b2958e92"

export default script